import apiService from './api';
class DashboardService {
    // Obter métricas gerais
    async getMetrics() {
        const response = await apiService.get('/dashboard/metrics');
        return response.data || {
            clientes: { total: 0, ativos: 0, novosHoje: 0, novosMes: 0 },
            ordensServico: { total: 0, abertas: 0, emAndamento: 0, concluidas: 0, hoje: 0, mes: 0 },
            vendas: { hoje: 0, mes: 0, ano: 0 },
            faturamento: { hoje: 0, mes: 0, ano: 0 },
            produtos: { total: 0, ativos: 0, estoqueZero: 0, estoqueMinimo: 0 },
            equipamentos: { total: 0, ativos: 0 }
        };
    }
    // Obter dados do gráfico de vendas
    async getVendasChart() {
        const response = await apiService.get('/dashboard/vendas-chart');
        return response.data || [];
    }
    // Obter top produtos mais vendidos
    async getTopProdutos() {
        const response = await apiService.get('/dashboard/top-produtos');
        return response.data || [];
    }
    // Obter distribuição de estados das OS
    async getOSStatus() {
        const response = await apiService.get('/dashboard/os-status');
        return response.data || [];
    }
    // Obter vendas por forma de pagamento
    async getVendasPagamento() {
        const response = await apiService.get('/dashboard/vendas-pagamento');
        return response.data || [];
    }
    // Obter atividade recente
    async getAtividadeRecente() {
        const response = await apiService.get('/dashboard/atividade-recente');
        return response.data || [];
    }
    // Obter alertas detalhados de estoque
    async getAlertas() {
        const response = await apiService.get('/dashboard/alerts');
        return response.data || { semEstoque: [], estoqueMinimo: [] };
    }
    // Obter relatório detalhado de vendas
    async getRelatorioVendas(dataInicio, dataFim) {
        const params = new URLSearchParams();
        if (dataInicio)
            params.append('dataInicio', dataInicio);
        if (dataFim)
            params.append('dataFim', dataFim);
        const response = await apiService.get(`/dashboard/relatorio-vendas?${params.toString()}`);
        return response.data || {
            vendas: [],
            resumo: { totalVendas: 0, subtotal: 0, totalIva: 0, total: 0, ticketMedio: 0 }
        };
    }
    // Obter relatório detalhado de ordens de serviço
    async getRelatorioOS(dataInicio, dataFim, estado) {
        const params = new URLSearchParams();
        if (dataInicio)
            params.append('dataInicio', dataInicio);
        if (dataFim)
            params.append('dataFim', dataFim);
        if (estado)
            params.append('estado', estado);
        const response = await apiService.get(`/dashboard/relatorio-os?${params.toString()}`);
        return response.data || {
            ordensServico: [],
            resumo: { totalOS: 0, valorOrcamento: 0, valorTotal: 0, tempoMedioResolucao: 0 }
        };
    }
}
// Instância singleton
const dashboardService = new DashboardService();
export default dashboardService;
// Utilitários para formatação
export const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
export const formatNumber = (value) => {
    return new Intl.NumberFormat('pt-PT').format(value);
};
export const formatDate = (dateString) => {
    return new Intl.DateTimeFormat('pt-PT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(new Date(dateString));
};
export const formatDateTime = (dateString) => {
    return new Intl.DateTimeFormat('pt-PT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(dateString));
};
// Cores para gráficos
export const chartColors = {
    primary: '#3b82f6',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    info: '#06b6d4',
    secondary: '#6b7280'
};
// Estados das OS com cores
export const osStatusColors = {
    'ABERTA': '#3b82f6',
    'DIAGNOSTICO': '#f59e0b',
    'ORCAMENTO_ENVIADO': '#8b5cf6',
    'ORCAMENTO_APROVADO': '#10b981',
    'EM_REPARACAO': '#06b6d4',
    'CONCLUIDA': '#10b981',
    'ENTREGUE': '#6b7280',
    'CANCELADA': '#ef4444'
};
// Labels em português para estados das OS
export const osStatusLabels = {
    'ABERTA': 'Aberta',
    'DIAGNOSTICO': 'Diagnóstico',
    'ORCAMENTO_ENVIADO': 'Orçamento Enviado',
    'ORCAMENTO_APROVADO': 'Orçamento Aprovado',
    'EM_REPARACAO': 'Em Reparação',
    'CONCLUIDA': 'Concluída',
    'ENTREGUE': 'Entregue',
    'CANCELADA': 'Cancelada'
};
// Labels para formas de pagamento
export const pagamentoLabels = {
    'DINHEIRO': 'Dinheiro',
    'MBWAY': 'MB WAY',
    'MULTIBANCO': 'Multibanco',
    'TRANSFERENCIA': 'Transferência',
    'CARTAO': 'Cartão',
    'CHEQUE': 'Cheque'
};
